import { GenericBackendResponse } from '../../genericBackendResponse';
import { IndexaToken } from './interfaces/IndexaToken';

interface CreateIndexaTokenDto {
	indexaApiKey: string;
}

const saveIndexaToken = async (
	token: string,
	data: CreateIndexaTokenDto
): Promise<GenericBackendResponse<IndexaToken>> => {
	try {
		const response = await fetch(`${process.env.REACT_APP_BASE_API}/thirdparty/indexa/token`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(data)
		});

		const responseData = await response.json();

		return responseData;
	} catch (error) {
		console.error('Error saving Indexa token:', error);
		return {
			success: false,
			data: {} as IndexaToken,
			code: 500,
			responseAt: new Date().toISOString(),
			debugId: 'indexa-token-save-error',
			message: 'Error al guardar el token de Indexa Capital'
		};
	}
};

export default saveIndexaToken;
